/** Preserve deep links, including their filters, without accepting external redirects. */
export function authDestination(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;
  const path =
    typeof from === 'string'
      ? from
      : from && typeof from === 'object' && 'pathname' in from && typeof from.pathname === 'string'
        ? from.pathname +
          ('search' in from && typeof from.search === 'string' ? from.search : '') +
          ('hash' in from && typeof from.hash === 'string' ? from.hash : '')
        : '/';
  return path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.includes('\\') &&
    !/^\/(login|register)([/?#]|$)/.test(path)
    ? path
    : '/';
}
